<template>
  <div class="memberCenter_wrap ContactsChange">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>修改联系人信息</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap" :style="{ height }">
      <div class="change_inform">
        <div class="title">联系人信息</div>
        <el-form :inline="true" :model="form" :rules="rules" v-if="type == '法人或其他组织'" :inline-message="true" ref="ruleForm1">
          <el-form-item label="联系人" prop="Contact">
            <el-input v-model="form.Contact"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="Mobile">
            <el-input v-model="form.Mobile"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="CertificateType">
            <el-select v-model="form.CertificateType">
              <el-option :label="item.text" :value="item.value" :checked="item.selected" v-for="(item, index) in form.CertificateTypeList" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="CertificateNo">
            <el-input v-model="form.CertificateNo"></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="ContactAddress">
            <el-input v-model="form.ContactAddress"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="Email">
            <el-input v-model="form.Email"></el-input>
          </el-form-item>
        </el-form>
        <el-form :inline="true" :model="form" :rules="rules" v-if="type == '自然人'">
          <el-form-item label="联系电话" prop="Mobile">
            <el-input v-model="form.Mobile"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="Email">
            <el-input v-model="form.Email"></el-input>
          </el-form-item>
          <el-form-item label="证现居住地址" prop="ContactAddress">
            <el-input v-model="form.ContactAddress"></el-input>
          </el-form-item>
          <el-form-item label=" " class="empty"></el-form-item>
        </el-form>
      </div>
      <div class="btn_wrap">
        <span class="btn_1" @click="reflash">重 置</span>
        <span class="btn_1" @click="submit">确 定</span>
      </div>
    </div>
  </div>
</template>

<script>
import { validateEmail, validContact, validateIdCar2 } from '@/assets/js/util'
export default {
  inject: ['reload'],
  data() {
    return {
      height: document.body.clientHeight - 120 + 'px',
      type: '法人或其他组织',
      form: {
        value: '',
        region: []
      },
      certificateNo: '',
      rules: {
        Contact: [{ required: true, validator: validContact, trigger: 'blur' }],
        Mobile: [{ required: true, trigger: 'blur' }],
        CertificateNo: [{ required: true, message: '', trigger: 'blur' }],
        CertificateType: [{ required: true, message: '请输入证件类型', trigger: 'blur' }],
        ContactAddress: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        Email: [{ required: true, validator: validateEmail, trigger: 'blur' }]
      }
    }
  },
  computed: {
    CertificateNo() {
      return this.form.CertificateNo
    },
    CertificateType() {
      return this.form.CertificateType
    }
  },
  watch: {
    CertificateType(newVal, oldVal) {
      if (newVal == 1) {
        //身份证验证
        this.rules.CertificateNo[0].validator = validateIdCar2
      } else {
        delete this.rules.CertificateNo[0].validator
      }
    },
    CertificateNo(newVal, oldVal) {
      if (newVal == this.certificateNo) {
        delete this.rules.CertificateNo[0].validator
      } else {
        if (this.form.CertificateType == 1) {
          this.rules.CertificateNo[0].validator = validateIdCar2
        }
      }
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    back() {
      this.$router.push('/MemberCenter')
    },
    getData() {
      this.getRequest('SupplierLogin/ContactEdit', {}).then((res) => {
        if (res.data.errcode == 0) {
          this.form = res.data.data
          this.certificateNo = this.form.CertificateNo
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    submit() {
      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          this.postRequest('SupplierLogin/UpdateContact', {
            contactDataJson: JSON.stringify(this.form)
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.$message({ type: 'success', message: '修改成功！' })
                this.back()
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
    },
    reflash() {
      this.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.ContactsChange {
  ::v-deep .el-form {
    margin: 15px;
  }
  .btn_wrap {
    width: 366px;
    margin: 60px auto 0;
    .btn_1 {
      background: #0774d7;
      color: #fff;
      border: none;
      border-radius: 10px;
    }
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
</style>
